import {webSocketLogin, heart, connect} from './websocket_core'
import {receiveMessage} from './websocket_message';
import websoketForSafari from "./websoketForSafari";

export let websock,worker = {} ;
/**
 *  lockReconnect 避免重复连接
 *  methods 收集方法队列
 * @type {number}
 */
export let timeout = 10000, lockReconnect = false,methods = [],bValue = '';
  worker={
    port:{
      postMessage(param){
        methods.forEach(method=>{
          method.call(this,{data:param});
        })
      },
    }
  }
  Object.defineProperty(worker.port, "onmessage", {
    // 使用了方法名称缩写（ES2015 特性）
    // 下面两个缩写等价于：
    // get : function() { return bValue; },
    // set : function(newValue) { bValue = newValue; },
    get() { return bValue; },
    set(newValue) {
       methods.push(newValue);
       bValue = newValue;
      },
    enumerable : true,
    configurable : true
  });

  websoketForSafari(worker);


  // contentFlag = false
export function initWebsocket() {
  let wsuri = process.env.VUE_APP_WSURI;

  worker.port.postMessage({method: "init",url:wsuri});
  worker.port.onmessage = function (event){
    if(event.data.method== "websocketonopen"){
       websocketonopen(event.data.eventData);
    }
    if(event.data.method== "websocketonerror"){
      websocketonerror(event.data.eventData);
    }
    if(event.data.method== "websocketonmessage"){
      //console,log(event.data.eventData)
      websocketonmessage(event.data.eventData);
    }
    if(event.data.method== "websocketclose"){
      websocketclose(event.data.eventData);
    }
    if(event.data.method== "heartcheck"){
      heartCheck();
    }
  }
  return


  websock.binaryType = "arraybuffer";
}

var timeoutObj = null;
var serverTimeoutObj = null;


//链接成功
export function websocketonopen() {
  // console.log("WebSocket连接成功");
  // store.dispatch('SET_SOCKET_STATUS', { code: "success", data: {} })
  connect()
}

//链接失败
export function websocketonerror(e) {
  //console,log("WebSocket连接发生错误");
  // store.dispatch('SET_SOCKET_STATUS', { code: "error", data: {} })
  worker.port.postMessage({method: "close"});
}

//返回信息
export function websocketonmessage(evt) {
  // store.dispatch('SET_SOCKET_BACK_DATA', new Uint8Array(evt.data))
  //收到消息处理类
  receiveMessage(evt)
}

//发送数据
export function websocketsend(agentData) {
  worker.port.postMessage({method:"send",data:agentData});
}

//链接关闭
export function websocketclose(e) {
  // store.dispatch('SET_SOCKET_STATUS', { code: "close", data: { code: e.code } })
  reconnect();
  //console,log("connection closed (" + e.code + ")");
}

//重连
export const reconnect = (function () {
    let timer = null;
    //关闭前重连

    return function () {
      if(!timer){
        if(lockReconnect) return;
        lockReconnect = true;
        timer = setTimeout(function () { //没连接上会一直重连，设置延迟避免请求过多
          initWebsocket();
          lockReconnect = false;
          timer = null;
        }, 2000);
      }
    }
  })()

//心跳时间重置
export function webSocketReset() {
  if(timeoutObj)clearTimeout(timeoutObj);
  if(serverTimeoutObj)clearTimeout(serverTimeoutObj);
}

//心跳检测
export function heartCheck() {
  console.log("心跳")
  var self = this;
  //webSocketReset();
  if(timeoutObj)clearTimeout(timeoutObj);
  timeoutObj = setTimeout(function () {
    heart();
    if(serverTimeoutObj)clearTimeout(serverTimeoutObj);
    serverTimeoutObj = setTimeout(function () {
      //worker.port.postMessage({method: "close"});
    }, timeout*2 );

  }, timeout)
}
